import { ReactComponent as Linkedin } from "../../../assets/vectors/icons/linkedin.svg";
import { ReactComponent as Youtube } from "../../../assets/vectors/icons/youtube.svg";
import { SOCIAL_LINKS } from "../../../config/env";

export const socialLinks = [
	{ name: "Linkedin", logo: Linkedin, link: SOCIAL_LINKS.linkedin },
	{ name: "Youtube", logo: Youtube, link: SOCIAL_LINKS.youtube },
];
